// @deprecated All users have new navigation, this hook will be removed soon. See https://checkout.atlassian.net/browse/DASH-2789
export function useHasNewNavigation() {
    return true;
}
